<template>
  <div>
    <section-header ref="selectHeader" title="Select Year"></section-header>
    <year-selection labeledBy="selectionHeader"></year-selection>
    <app-navigator
      ref="appNavigator"
      :router="$router"
      nextButtonTitle="Select one or more years to continue"
    ></app-navigator>
  </div>
</template>

<script>
/* eslint no-unused-vars: 'off' */
import yearSelection from "@/components/yearSelection";
import current from "@/scripts/current";
import commonModelHelper from "@/scripts/commonModelHelper";
import metricsHelper from "@/scripts/metricsHelper";
import commonTestHelper from "@/scripts/commonTestHelper";
import sectionHeader from "@/components/sub/sectionHeader";
import appNavigator from "@/components/layout/appNavigator";
//  import store from '@/store';

export default {
  created: function () {},
  components: {
    // <my-component> will only be available in parent's template
    yearSelection,
    sectionHeader,
    appNavigator,
  },
  data: function () {
    var vm = this;

    //      store.dispatch('display/setPage', 'crossTabulation');
    current.initializeCrossTabulationValues(vm);
    metricsHelper.startAnalysis();
    commonModelHelper.initializeStep(vm, "years");
    commonTestHelper.setIsInAutomatedTesting(vm.$route);
    if (window.inAutomatedTesting)
      this.$router.push({
        path: "/crossTabulation/viewReport",
        query: { test: "true", id: 0 },
      });

    return {};
  },
  methods: {},
};
</script>

<style scoped>
</style>
